import { css } from 'lit';

export const embedNoteContentStyles = css`
  .hive-embed-doc-content-note-blocks hive-divider,
  .hive-embed-doc-content-note-blocks hive-divider > * {
    margin-top: 0px !important;
    margin-bottom: 0px !important;
    padding-top: 8px;
    padding-bottom: 8px;
  }
  .hive-embed-doc-content-note-blocks hive-paragraph,
  .hive-embed-doc-content-note-blocks hive-list {
    margin-top: 4px !important;
    margin-bottom: 4px !important;
    padding: 0 2px;
  }
  .hive-embed-doc-content-note-blocks hive-paragraph *,
  .hive-embed-doc-content-note-blocks hive-list * {
    margin-top: 0px !important;
    margin-bottom: 0px !important;
    padding-top: 0;
    padding-bottom: 0;
    line-height: 20px;
    font-size: var(--hive-font-xs);
    font-weight: 400;
  }
  .hive-embed-doc-content-note-blocks hive-list .hive-list-block__prefix {
    height: 20px;
  }
  .hive-embed-doc-content-note-blocks hive-paragraph .quote {
    padding-left: 15px;
    padding-top: 8px;
    padding-bottom: 8px;
  }
  .hive-embed-doc-content-note-blocks hive-paragraph:has(.h1),
  .hive-embed-doc-content-note-blocks hive-paragraph:has(.h2),
  .hive-embed-doc-content-note-blocks hive-paragraph:has(.h3),
  .hive-embed-doc-content-note-blocks hive-paragraph:has(.h4),
  .hive-embed-doc-content-note-blocks hive-paragraph:has(.h5),
  .hive-embed-doc-content-note-blocks hive-paragraph:has(.h6) {
    margin-top: 6px !important;
    margin-bottom: 4px !important;
    padding: 0 2px;
  }
  .hive-embed-doc-content-note-blocks hive-paragraph:has(.h1) *,
  .hive-embed-doc-content-note-blocks hive-paragraph:has(.h2) *,
  .hive-embed-doc-content-note-blocks hive-paragraph:has(.h3) *,
  .hive-embed-doc-content-note-blocks hive-paragraph:has(.h4) *,
  .hive-embed-doc-content-note-blocks hive-paragraph:has(.h5) *,
  .hive-embed-doc-content-note-blocks hive-paragraph:has(.h6) * {
    margin-top: 0px !important;
    margin-bottom: 0px !important;
    padding-top: 0;
    padding-bottom: 0;
    line-height: 20px;
    font-size: var(--hive-font-xs);
    font-weight: 600;
  }

  .hive-embed-linked-doc-block.horizontal {
    hive-paragraph,
    hive-list {
      margin-top: 0 !important;
      margin-bottom: 0 !important;
      max-height: 40px;
      overflow: hidden;
      display: flex;
    }
    hive-paragraph .quote {
      padding-top: 4px;
      padding-bottom: 4px;
      height: 28px;
    }
    hive-paragraph .quote::after {
      height: 20px;
      margin-top: 4px !important;
      margin-bottom: 4px !important;
    }
  }
`;
